import * as React from 'react';
import { TableListItemProps, DragHandleSizes } from '../TableListItem';
import { indentSizes } from './constants';

export type Action = {
  label: string;
  onClick(e: Event, item?: NestableListItem): void;
  prefixIcon?: React.ReactNode;
};

export type NestableListItem = {
  id: string | number;
  actionsDataHook?: string;
  draggable?: boolean;
  hideDragHandle?: boolean;
  isCollapsed?: boolean;
  addItemLabel?: string;
  actions?: Action[];
  children?: NestableListItem[];
} & TableListItemProps;

export type NestableListIndentSize = (typeof indentSizes)[number];

export interface NestableListProps {
  dataHook?: string;
  withBottomBorder?: boolean;
  className?: string;
  readOnly?: boolean;
  actions?: Action[];
  items: NestableListItem[];
  preventChangeDepth?: boolean;
  preventChangeParent?: boolean;
  showDragHandleOnHover?: boolean;
  dragHandleSize?: DragHandleSizes;
  enforcePinnedOrder?: boolean;
  maxDepth?: number;
  addItemLabel?: string;
  onChange?(data: { items: NestableListItem[]; item: NestableListItem }): void;
  onAddItem?(item: NestableListItem): void;
  zIndex?: number;
  dividers?: boolean;
  indentSize?: NestableListIndentSize;
  hierarchyIndicator?: boolean;
  onDragStart?: () => void;
  onDragEnd?: () => void;
}

export default class NestableList extends React.PureComponent<NestableListProps> {}
